import { Box } from '@factorialco/deprecated-design-system'
import { Dropdown } from '@factorialco/factorial-one-react/dist/experimental'
import {
  Bullet,
  Check,
  Delete,
  Numbers,
  Star,
  TextSize,
} from '@factorialco/factorial-one-react/icons/app'
import { FormsElementTypeEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

const SectionSidebarDropdown = ({
  isVisible,
  sectionId,
  onAddElement,
  onDelete,
}: {
  sectionId: string
  isVisible: boolean
  onAddElement: (type: FormsElementTypeEnum, sectionId: string | null) => void
  onDelete: () => void
}) => {
  return (
    <Box style={{ visibility: isVisible ? 'visible' : 'hidden' }}>
      <Dropdown
        items={[
          {
            label: i18n.t('forms.modals.add_elements.single_choice'),
            icon: Bullet,
            onClick: () => onAddElement('select', sectionId),
          },
          {
            label: i18n.t('forms.modals.add_elements.multiple_choice'),
            icon: Check,
            onClick: () => onAddElement('multiselect', sectionId),
          },
          {
            label: i18n.t('forms.modals.add_elements.rating'),
            icon: Star,
            onClick: () => onAddElement('rating', sectionId),
          },
          {
            label: i18n.t('forms.modals.add_elements.numeric'),
            icon: Numbers,
            onClick: () => onAddElement('number', sectionId),
          },
          {
            label: i18n.t('forms.modals.add_elements.text'),
            icon: TextSize,
            onClick: () => onAddElement('text', sectionId),
          },
          { type: 'separator' },
          //TODO: This will need to change to a proper duplicate method
          // {
          //   label: i18n.t('forms.modals.actions.duplicate'),
          //   icon: Folders,
          //   onClick: () => handledDuplicateElement(),
          // },
          {
            label: i18n.t('forms.modals.actions.delete'),
            icon: Delete,
            onClick: onDelete,
          },
        ]}
      />
    </Box>
  )
}

export default SectionSidebarDropdown
